import { call, put, takeEvery,takeLatest } from "redux-saga/effects"

// Crypto Redux States
import {
  GET_USERS,
  GET_USER_DETAIL,
  ADD_NEW_USER,
  UPDATE_USER,
  DELETE_USER,
  UPDATE_SEASON_CHANGE_STATUS,
  BLACKLIST_USER,
  GET_UNAPPROVE_COUNT,
  GET_EXPORT_USERS,
  GET_BILL_PRICE,
  CHARGE_USER,
  GET_CHANGESEASON_USERS,
} from "./actionTypes"
import {
  getUsersSuccess,
  getUsersFail,
  getUserDetailSuccess,
  getUserDetailFail,
  addUserFail,
  addUserSuccess,
  updateUserSuccess,
  updateUserFail,
  deleteUserSuccess,
  deleteUserFail,
  updateUserSeasonChangeSuccess,
  updateUserSeasonChangeFail,
  blacklistUserSuccess,
  blacklistUserFail,
  getUnApprovalCountSuccess,
  getUnApprovalCountFail,
  getExportUserSuccess,
  getExportUserFail,
  chargeUserSuccess,
  chargeUserFail,
  priceBillSuccess,
  priceBillFail,
  getChangeSeasonUsersSuccess,
  getChangeSeasonUsersFail,
} from "./actions"

//Include Both Helper File with needed methods
import {
  getUsers,
  getUsersDetails,
  addNewUser,
  updateUser,
  deleteUser,
  updateUserSeasonChange,
  blacklistUser,
  getUnApprovalCounts,
  getExportUsers,
  chargeUser,
  priceBill,
} from "helpers/backend_helper"

function* fetchUsers({ payload }) {
  try {
    const response = yield call(getUsers, payload)
    yield put(getUsersSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}
function* fetchChangeSeasonUsers({ payload }) {
  try {
    const response = yield call(getUsers, payload)
    yield put(getChangeSeasonUsersSuccess(response))
  } catch (error) {
    yield put(getChangeSeasonUsersFail(error))
  }
}


function* fetchUnApprovalCounts({ payload }) {
  try {
    const response = yield call(getUnApprovalCounts, payload)
    yield put(getUnApprovalCountSuccess(response))
  } catch (error) {
    yield put(getUnApprovalCountFail(error))
  }
}

function* fetchUserDetail({ UserId }) {
  try {
    const response = yield call(getUsersDetails, UserId)
    yield put(getUserDetailSuccess(response))
  } catch (error) {
    yield put(getUserDetailFail(error))
  }
}

function* onUpdateUser({ payload: User }) {
  try {
    const response = yield call(updateUser, User)
    if (response?.success) {
      yield put(updateUserSuccess(response))
    } else {
      yield put(updateUserFail(response))
    }
  } catch (error) {
    yield put(updateUserFail(error))
  }
}

function* onAddNewUser({ payload: User }) {
  try {
    const response = yield call(addNewUser, User)
    if (response?.success) {
      yield put(addUserSuccess(response))
    } else {
      yield put(addUserFail(response))
    }
  } catch (error) {
    yield put(addUserFail(error))
  }
}

function* onDeleteUser({ payload: user }) {
  try {
    const response = yield call(deleteUser, user)
    if (response?.success) {
      yield put(deleteUserSuccess({user, response}))
    } else {
      yield put(deleteUserFail(response))
    }
  } catch (error) {
    yield put(deleteUserFail(error))
  }
}

function* onBlacklistUser({ payload: user }) {
  try {
    const response = yield call(blacklistUser, user)
    if (response?.success) {
      yield put(blacklistUserSuccess(user))
    } else {
      yield put(blacklistUserFail(response))
    }
  } catch (error) {
    yield put(blacklistUserFail(error))
  }
}

function* onUpdateSeasonChange({ payload: user }) {
  try {
    const response = yield call(updateUserSeasonChange, user)
    if (response?.success) {
      yield put(updateUserSeasonChangeSuccess(user))
    } else {
      yield put(updateUserSeasonChangeFail(response))
    }
  } catch (error) {
    yield put(updateUserSeasonChangeFail(error))
  }
}

function* fetchExportUsers({ payload }) {
  try {
    const response = yield call(getExportUsers, payload)
    if (response?.success) {
      yield put(getExportUserSuccess(response))
    }else {
      yield put(getExportUserFail(response))
    }
  } catch (error) {
    yield put(getExportUserFail(error))
  }
}


function* onChargeUser({ payload: user }) {
  try{
    const response = yield call(chargeUser, user)
    if (response?.success) {
      yield put(chargeUserSuccess(response))
    } else {
      yield put(chargeUserFail(response))
    }
  } catch (error) {
    yield put(chargeUserFail(error))
  }
}

function* onPriceBill({ payload: user }) {
  try{
    const response = yield call(priceBill, user)
    if (response?.success) {
      yield put(priceBillSuccess(response))
    } else {
       yield put(priceBillFail(response))
    }
  } catch (error) {
    yield put(priceBillFail(error))
  }
}

function* UsersSaga() {
  yield takeEvery(GET_USERS, fetchUsers)
  yield takeEvery(GET_USER_DETAIL, fetchUserDetail)
  yield takeEvery(ADD_NEW_USER, onAddNewUser)
  yield takeEvery(UPDATE_USER, onUpdateUser)
  yield takeEvery(DELETE_USER, onDeleteUser)
  yield takeEvery(BLACKLIST_USER, onBlacklistUser)
  yield takeEvery(UPDATE_SEASON_CHANGE_STATUS, onUpdateSeasonChange)
  yield takeEvery(GET_UNAPPROVE_COUNT, fetchUnApprovalCounts)
  yield takeEvery(GET_EXPORT_USERS, fetchExportUsers)
  yield takeEvery(CHARGE_USER, onChargeUser)
  yield takeLatest(GET_BILL_PRICE, onPriceBill)  
  yield takeEvery(GET_CHANGESEASON_USERS, fetchChangeSeasonUsers)
}

export default UsersSaga
